/**
 * Rows of the products export (Settings → Export/Import), one per product, for ONE store.
 *
 * ATL-2064: the export is per store — the merchant picks a store and the price and stock columns
 * are that store's — so the rows are that store's product list: only products with
 * `activeInStore[store] === true`, the same predicate the store's catalog uses
 * (`getProductsList(productsDict, true, store)`). Before, every product of the organization was
 * written, and products switched off in the store came out with an empty price or zero stock.
 *
 * CSV and Excel are both written from these rows (`exportToCSV` / `exportToExcel`), so the two
 * formats cannot disagree about which products are in the file.
 *
 * Order is catalog order (ATL-968). Values are written as they are; `exportToCSV` quotes a comma.
 */

import { getProductsList } from "./productListHelpers";

export const productExportRows = (
  productsDict,
  store,
  t,
  { productCategoriesDict, suppliersDict },
) => {
  // A per-store export without a store has no rows to give and no price/stock column to fill;
  // refusing is the only answer that does not write a file which looks complete and is not.
  if (store === null || store === undefined) {
    throw new Error("productExportRows: a store is required");
  }
  return getProductsList(productsDict, true, store).map((product) => ({
    [t("exportImport.name")]: product.name,
    [t("exportImport.price")]: product.salePrices[store],
    [t("exportImport.purchasePrice")]: product.purchasePrice,
    [t("exportImport.barcode")]: product.barcode,
    [t("exportImport.category")]:
      productCategoriesDict[product.categoryID]?.name,
    [t("exportImport.supplier")]: suppliersDict[product.supplierID]?.name,
    [t("exportImport.inStock")]: product.storeStock[store],
    [t("exportImport.externalId")]: product.id,
  }));
};
